// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-fade-enter-active{transition:all 1s ease;opacity:0;transform:translateY(50px)}.alert-fade-enter-to{transition:all 1s ease;opacity:1;transform:translateY(0)}.alert-fade-leave-to{transition:all 1s ease;opacity:0}.alert-fade-leave-active{transition:all 1s ease;transform:translateY(50px)}", ""]);
// Exports
module.exports = exports;
